export default function TransportsConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('transports');
}

TransportsConfiguration.$inject = ['$translatePartialLoaderProvider'];
